<template>
    <div :id="id" v-bind:style="style"></div>
</template>
<script>
import MapPage from './maptalks-map';
import { v4 as uuid } from 'uuid';

export default {
    props: {
        modelValue: {
            type: Array,
        },
        objects: {
            type: Array,
            default: []
        }
    },
    emits: ['selectIds'],
    async mounted() {
        this.initMap(this.objects);
    },
    methods: {
        initMap(objects) {
            const element = document.getElementById(this.id);
            const initData = window.BaseApp.initData;
            this.map = new MapPage(element, {
                initData,
                fullscreen: false,
                event: {
                    onChoiceElem: (ids) => {
                        this.$emit('selectIds', ids);
                    },
                },
            });

            this.map.init(objects);
            this.map.refresh();
        },
    },
    watch: {
        objects: {
            handler() {
                this.map.init(this.objects);
            },
            deep: true
        }
    },
    data() {
        return {
            map: null,
            id: uuid(),
            style: {
                width: '100%',
                height: '-webkit-fill-available',
                position: 'absolute',
                zIndex: '99'
            }
        };
    },
};
</script>
